module.exports = __webpack_public_path__ + "static/img/11.f00e260.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/zh/11.png
// module id = kR3T
// module chunks = 0